// Fünf Abschnitte, eine Datenmenge: alle Ansichten sind Projektionen derselben
// n:m-Beziehung aus /public/events/:slug/exhibitors (Spec Abschnitt 4.1/6.1).
// Umgruppieren geschieht im Client, damit ein Kachelwechsel ohne Netzverkehr geht.
const compare = (a, b) => a.localeCompare(b, 'de')

export const byExhibitor = ({ exhibitors }) => exhibitors

export const byProfession = ({ exhibitors }) => {
    const byId = new Map()

    for (const exhibitor of exhibitors) {
        for (const profession of exhibitor.professions) {
            const entry = byId.get(profession.id) || { ...profession, exhibitors: [] }
            entry.exhibitors.push(exhibitor)
            byId.set(profession.id, entry)
        }
    }

    return [...byId.values()]
        .sort((a, b) => compare(a.title, b.title))
        .map(entry => ({ ...entry, exhibitors: [...entry.exhibitors].sort((a, b) => compare(a.name, b.name)) }))
}

export const byTheme = (data) => {
    const professions = byProfession(data)

    return data.themeCategories
        .map(category => ({
            ...category,
            professions: professions.filter(p => (p.themeCategoryIds || []).includes(category.id))
        }))
        .filter(category => category.professions.length > 0)
}

// „(Duale) Studiengänge" ist eine Projektion über den Typ der Angebote
// (Spec Abschnitt 4.3).
export const onlyType = ({ exhibitors }, types) => exhibitors
    .map(exhibitor => ({ ...exhibitor, professions: exhibitor.professions.filter(p => types.includes(p.type)) }))
    .filter(exhibitor => exhibitor.professions.length > 0)

// „Praktikumsplätze" dagegen hängt am Aussteller, nicht am Angebot: die alte
// Seite listet dort schlicht die Namen der Betriebe, die Praktika anbieten (#13).
// Die Berufe werden bewusst weggelassen — die Liste zeigt nur Namen.
export const offeringInternship = ({ exhibitors }) => exhibitors
    .filter(exhibitor => exhibitor.internship)
    .map(({ professions, ...exhibitor }) => exhibitor)
